var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('div',{staticClass:"h-stack h-space-between"},[_c('a',{staticClass:"heading-title-2",staticStyle:{"align-self":"center"}},[_vm._v("Expenses")]),_c('button',{staticClass:"add",on:{"click":function($event){return _vm.$router.push('/finance/expenses/add/gear')}}},[_vm._v(" Add Expense ")])]),_c('div',{staticClass:"card light mn"},[_c('div',{staticClass:"content h-stretch"},[(_vm.data)?_c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('div',{staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"v-stack h-stretch v-start gap-3 card py-5"},[_c('a',[_vm._v("One Time & Reccuring")]),_vm._l((_vm.categories),function(value,category){return _c('div',{key:category,staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(category)+":")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.format.currency(value))+" Kč ")])])})],2),_c('div',{staticClass:"v-stack h-stretch v-start gap-3 card py-5"},[_c('a',[_vm._v("Other")]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"text-right"},[_vm._v("Gear:")]),_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.format.currency(_vm.data.gear))+" kč")])]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"text-right"},[_vm._v("Crew:")]),_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.format.currency(_vm.data.crew))+" kč")])])])]),_c('div',{staticClass:"v-stack h-stretch v-start gap-3 card py-5"},[_c('a',[_vm._v("Sum")]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"text-right"},[_vm._v("OneTime & Reccuring:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.format.currency(_vm.data.oneTimeAndRecurringTotal))+" kč ")])]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"text-right"},[_vm._v("Other:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.format.currency(_vm.data.otherTotal))+" kč ")])]),_c('div',{staticClass:"separator"}),_c('div',{staticClass:"pane-horizontal gap-3",staticStyle:{"font-weight":"bold"}},[_c('div',{staticClass:"text-right"},[_vm._v("Total:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.format.currency(_vm.data.total))+" kč ")])])])]):_c('div',[_c('span',{staticClass:"loader"})])])]),(_vm.data)?[_c('div',{staticClass:"h-stack gap-3 h-start v-center"},[_c('a',{staticClass:"heading-title-2"},[_vm._v("One Time Expenses")]),_c('label',[_vm._v("Category:")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryFilterOneTime),expression:"categoryFilterOneTime"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryFilterOneTime=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("all")]),_vm._l((_vm.data.oneTime.categories),function(value,category){return _c('option',{key:category,domProps:{"value":category}},[_vm._v(" "+_vm._s(category)+" ")])})],2)]),_c('div',{staticClass:"card light mn pn"},[_c('div',{staticClass:"card pa-5"},[_c('div',{staticClass:"v-stack h-stretch gap-3"},[_vm._l((_vm.data.oneTime.categories),function(value,category){return _c('div',{key:category,staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(category)+":")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.format.currency(value))+" Kč ")])])}),_c('div',{staticClass:"separator"}),_c('div',{staticClass:"pane-horizontal gap-2"},[_c('div',{staticClass:"text-right"},[_vm._v("Sum:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.format.currency(_vm.data.oneTime.total))+" Kč ")])])],2)])]),_c('Table',{attrs:{"items":_vm.filteredOneTimeExpenses,"loading":_vm.loadingOneTimeExpenses,"defaultColumn":0,"limit":10,"pageable":true,"height":360,"columns":[
        {
          name: 'Date',
          sort: 'date',
          path: ['date'],
          formatType: 'date',
          format: 'DD.MM.YYYY',
        },
        {
          name: 'Category',
          sort: 'alphabet',
          path: ['category'],
        },
        {
          name: 'Title',
          sort: 'alphabet',
          path: ['name'],
        },
        {
          name: 'Amount',
          sort: 'numeric',
          path: ['amount'],
          format: 'czk',
          formatType: 'currency',
        },
        {
          name: 'Store',
          sort: 'alphabet',
          path: ['store'],
        },
        {
          name: 'Description',
          sort: 'alphabet',
          path: ['description'],
        },
      ]},on:{"rowSelected":function($event){return _vm.$router.push('/finance/expenses/edit/' + $event._id)}}}),_c('div',{staticClass:"h-stack gap-3 v-center h-start"},[_c('a',{staticClass:"heading-title-2"},[_vm._v("Reccuring Expenses")]),_c('label',[_vm._v("Category:")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryFilterReccuring),expression:"categoryFilterReccuring"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryFilterReccuring=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("all")]),_vm._l((_vm.data.recurring.categories),function(value,category){return _c('option',{key:category,domProps:{"value":category}},[_vm._v(" "+_vm._s(category)+" ")])})],2)]),_c('div',{staticClass:"card light mn pn"},[_c('div',{staticClass:"card pa-5"},[_c('div',{staticClass:"v-stack h-stretch gap-3"},[_vm._l((_vm.data.recurring.categories),function(value,category){return _c('div',{key:category,staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(category)+":")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.format.currency(value))+" Kč ")])])}),_c('div',{staticClass:"separator"}),_c('div',{staticClass:"pane-horizontal gap-2"},[_c('div',{staticClass:"text-right"},[_vm._v("Sum:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.format.currency(_vm.data.recurring.total))+" Kč ")])])],2)])]),_c('Table',{attrs:{"items":_vm.filteredRecurringExpenses,"defaultColumn":0,"limit":10,"height":360,"pageable":true,"columns":[
        {
          name: 'Date',
          sort: 'date',
          path: ['date'],
          formatType: 'date',
          format: 'DD.MM.YYYY',
        },
        {
          name: 'Category',
          sort: 'alphabet',
          path: ['category'],
        },
        {
          name: 'Title',
          sort: 'alphabet',
          path: ['name'],
        },
        {
          name: 'Store',
          sort: 'alphabet',
          path: ['store'],
        },
        {
          name: 'End Date',
          sort: 'date',
          path: ['reccuringEndDate'],
          formatType: 'date',
          format: 'DD.MM.YYYY',
        },
        {
          name: 'Amount',
          sort: 'numeric',
          path: ['amount'],
          format: 'czk',
          formatType: 'currency',
        },
        {
          name: 'Description',
          sort: 'alphabet',
          path: ['description'],
        },
      ]},on:{"rowSelected":function($event){return _vm.$router.push('/finance/expenses/edit/' + $event.reference)}}}),_c('a',{staticClass:"heading-title-1"},[_vm._v("Gear")]),_c('div',{staticClass:"card light mn pn"},[_c('div',{staticClass:"card pa-5"},[_c('div',{staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"text-right"},[_vm._v("Sum:")]),_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.format.currency(_vm.data.gear))+" Kč")])])])]),_c('a',{staticClass:"heading-title-2"},[_vm._v("Pricelist Gear")]),_c('Table',{attrs:{"items":_vm.gearInPricelist,"loading":_vm.loadingGearExpenses,"defaultColumn":0,"limit":10,"height":360,"pageable":true,"columns":[
        {
          name: 'Date',
          sort: 'date',
          path: ['dateOfPurchase'],
          formatType: 'date',
          format: 'DD.MM.YYYY',
        },
        {
          name: 'Serial Number',
          sort: 'alphabet',
          path: ['serialNumber'],
        },
        {
          name: 'Store Description',
          sort: 'alphabet',
          path: ['storeDescription'],
        },
        {
          name: 'Cost',
          sort: 'numeric',
          path: ['value'],
          format: 'czk',
          formatType: 'currency',
        },
        {
          name: 'Description',
          sort: 'alphabet',
          path: ['description'],
        },
      ]},on:{"rowSelected":function($event){return _vm.$router.push('/pricelist/item/detail/' + $event.item._id)}}}),_c('a',{staticClass:"heading-title-2"},[_vm._v("One Time Gear Expenses")]),_c('Table',{attrs:{"items":_vm.oneTimeGearExpenses,"loading":_vm.loadingGearExpenses,"defaultColumn":0,"limit":10,"height":360,"pageable":true,"columns":[
        {
          name: 'Date',
          sort: 'date',
          path: ['date'],
          formatType: 'date',
          format: 'DD.MM.YYYY',
        },
        {
          name: 'Title',
          sort: 'alphabet',
          path: ['name'],
        },
        {
          name: 'Store',
          sort: 'alphabet',
          path: ['store'],
        },
        {
          name: 'Amount',
          sort: 'numeric',
          path: ['amount'],
          format: 'czk',
          formatType: 'currency',
        },
        {
          name: 'Description',
          sort: 'alphabet',
          path: ['description'],
        },
      ]},on:{"rowSelected":function($event){return _vm.$router.push('/finance/expenses/edit/' + $event._id)}}}),_c('a',{staticClass:"heading-title-2"},[_vm._v("Recurring Gear Expenses")]),_c('Table',{attrs:{"items":_vm.recurringGearExpenses,"loading":_vm.loadingGearExpenses,"defaultColumn":0,"limit":10,"height":360,"pageable":true,"columns":[
        {
          name: 'Date',
          sort: 'date',
          path: ['date'],
          formatType: 'date',
          format: 'DD.MM.YYYY',
        },
        {
          name: 'Title',
          sort: 'alphabet',
          path: ['name'],
        },
        {
          name: 'Store',
          sort: 'alphabet',
          path: ['store'],
        },
        {
          name: 'End Date',
          sort: 'date',
          path: ['reccuringEndDate'],
          formatType: 'date',
          format: 'DD.MM.YYYY',
        },
        {
          name: 'Amount',
          sort: 'numeric',
          path: ['amount'],
          format: 'czk',
          formatType: 'currency',
        },
        {
          name: 'Description',
          sort: 'alphabet',
          path: ['description'],
        },
      ]},on:{"rowSelected":function($event){return _vm.$router.push('/finance/expenses/edit/' + $event.reference)}}}),_c('a',{staticClass:"heading-title-1"},[_vm._v("Crew")]),_c('div',{staticClass:"card light mn pn"},[_c('div',{staticClass:"card pa-5"},[_c('div',{staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"text-right"},[_vm._v("Sum:")]),_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.format.currency(_vm.data.crew))+" Kč")])])])]),_c('Hours',{attrs:{"userFilter":'all',"period":_vm.period,"year":_vm.year,"month":_vm.month,"startDate":_vm.startDate,"endDate":_vm.endDate}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }